import React, { useState } from 'react'
import { useLanguage } from '~components'
import { FacCardForm as FacCardFormController } from '../PaymentOptionFacController/FacCardForm'
import { CreditCard2Front, Lock } from 'react-bootstrap-icons'

import {
  FormStripe,
  FormRow,
  ErrorMessage,
  FormActions,
  CustomCardForm,
  CardLogos,
  SaveCardCheckbox
} from './styles'

import {
  Button
} from '~ui'

const FacCardFormUI = (props) => {
  const {
    handleSubmit,
    onCancel,
    handlePay,
    handleChangeFacCardName,
    handleChangeFacCard,
    handleChangeFacMonth,
    handleChangeFacYear,
    handleChangeFacCvv,
    facCardData
  } = props

  const [, t] = useLanguage()
  const [focused, setFocused] = useState(null)
  const [saveForFuture, setSaveForFuture] = useState(false)

  const formatCardNumber = (e) => {
    let value = e.target.value.replace(/\D/g, '')
    // Limit to 16 digits
    value = value.slice(0, 16)
    e.target.value = value
    handleChangeFacCard()
    console.log(focused)
  }

  return (
    <>
      {props.beforeElements?.map((BeforeElement, i) => (
        <React.Fragment key={i}>
          {BeforeElement}
        </React.Fragment>))
      }
      {props.beforeComponents?.map((BeforeComponent, i) => (
        <BeforeComponent key={i} {...props} />))
      }

      {/* Card Logos */}
      <CardLogos>
        <img
          src='https://res.cloudinary.com/acuity/image/upload/v1673438464/fac_logo_xg4nqv.png'
          alt='PowerTranz'
        />
        <img
          src='https://res.cloudinary.com/acuity/image/upload/v1673438469/download_h10t8j.jpg'
          alt='Secure Payment'
        />
      </CardLogos>

      <FormStripe onSubmit={handleSubmit}>
        <FormRow>
          <CustomCardForm>
            {/* Card Holder Name */}
            <div className='left'>
              <div className='input-group'>
                <label className='input-label'>{t('CARD_HOLDER_NAME', 'Card Holder Name')}</label>
                <input
                  type='text'
                  name='card_holder'
                  id='card_holder'
                  placeholder={t('CARD_HOLDER_PLACEHOLDER', 'Enter name on card')}
                  autoComplete='cc-name'
                  onInput={handleChangeFacCardName}
                  onFocus={() => setFocused('name')}
                  onBlur={() => setFocused(null)}
                />
              </div>
            </div>

            {/* Card Number */}
            <div className='left'>
              <div className='input-group'>
                <label className='input-label'>{t('CARD_NUMBER', 'Card Number')}</label>
                <div className='input-with-icon'>
                  <input
                    type='tel'
                    name='card_number'
                    id='card_number'
                    maxLength='16'
                    className='card-number-input'
                    placeholder='0000 0000 0000 0000'
                    autoComplete='cc-number'
                    onInput={formatCardNumber}
                    onFocus={() => setFocused('number')}
                    onBlur={() => setFocused(null)}
                  />
                  <div className='card-icon-wrapper'>
                    <CreditCard2Front size={20} color='#ADB5BD' />
                  </div>
                </div>
              </div>
            </div>

            {/* Expiry Date and CVV */}
            <div className='right'>
              <div className='input-group' style={{ flex: 1 }}>
                <label className='input-label'>{t('EXPIRY_MONTH', 'MM')}</label>
                <input
                  type='tel'
                  name='exp_month'
                  id='exp_month'
                  maxLength='2'
                  className='expiry-input'
                  placeholder='MM'
                  autoComplete='cc-exp-month'
                  onInput={handleChangeFacMonth}
                  onFocus={() => setFocused('month')}
                  onBlur={() => setFocused(null)}
                />
              </div>

              <div className='input-group' style={{ flex: 1 }}>
                <label className='input-label'>{t('EXPIRY_YEAR', 'YY')}</label>
                <input
                  type='tel'
                  name='exp_year'
                  id='exp_year'
                  maxLength='2'
                  className='expiry-input'
                  placeholder='YY'
                  autoComplete='cc-exp-year'
                  onInput={handleChangeFacYear}
                  onFocus={() => setFocused('year')}
                  onBlur={() => setFocused(null)}
                />
              </div>

              <div className='input-group' style={{ flex: 1 }}>
                <label className='input-label'>{t('CVV', 'CVV')}</label>
                <input
                  type='password'
                  name='card_cvv'
                  id='card_cvv'
                  maxLength='4'
                  className='cvv-input'
                  placeholder='•••'
                  autoComplete='cc-csc'
                  inputMode='numeric'
                  onInput={handleChangeFacCvv}
                  onFocus={() => setFocused('cvv')}
                  onBlur={() => setFocused(null)}
                />
              </div>
            </div>

            {/* Security Notice */}
            <div className='secure-notice'>
              <Lock />
              <span>{t('SECURE_PAYMENT_NOTICE', 'Your payment information is encrypted and secure. We never store your full card details.')}</span>
            </div>
          </CustomCardForm>

          {/* Error Message */}
          {facCardData.err_msg && (
            <ErrorMessage>{facCardData.err_msg}</ErrorMessage>
          )}
        </FormRow>

        {/* Save Card Checkbox */}
        <SaveCardCheckbox>
          <label>
            <input
              type='checkbox'
              checked={saveForFuture}
              onChange={(e) => setSaveForFuture(e.target.checked)}
            />
            <span className='checkmark'></span>
            <span className='label-text'>
              {t('SAVE_CARD_FOR_FUTURE_PAYMENTS', 'Save card for future payments')}
            </span>
          </label>
        </SaveCardCheckbox>

        <FormActions>
          <Button type='button' onClick={() => onCancel()}>
            {t('CANCEL', 'Cancel')}
          </Button>
          <Button type='button' color='primary' onClick={() => handlePay(saveForFuture)}>
            {t('ADD_CARD', 'Add Card')}
          </Button>
        </FormActions>
      </FormStripe>

      {props.afterComponents?.map((AfterComponent, i) => (
        <AfterComponent key={i} {...props} />))
      }
      {props.afterElements?.map((AfterElement, i) => (
        <React.Fragment key={i}>
          {AfterElement}
        </React.Fragment>))
      }
    </>
  )
}

export const FacCardForm = (props) => {
  const FacCardFormProps = {
    ...props,
    UIComponent: FacCardFormUI
  }
  return <FacCardFormController {...FacCardFormProps} />
}
